import moment from 'moment';
import tchat from '@amo/core/assets/images/AMO_Icons/Tout-motards.svg';
import RecapGPTSection from './RecapGPTSection';

const RecapGPTConducteur = ({ personne, onEdit }) => {
    const dateNaissance = personne?.DateNaissance;
    const dateNaissanceMoment = dateNaissance
        ? (dateNaissance._isAMomentObject ? dateNaissance : moment(dateNaissance, 'DD/MM/YYYY'))
        : null;
    const age = dateNaissanceMoment?.isValid() ? moment().diff(dateNaissanceMoment, 'years') : null;

    const permis = personne?.ListePermis || [];
    const permisActifs = permis.filter((p) => p?.TypePermis);

    return (
        <RecapGPTSection title="Mon profil" icon={tchat} onEdit={onEdit}>
            {dateNaissance && (
                <p>
                    <span className={'text-dark fw-bold'}>
                        {dateNaissanceMoment?.isValid() ? dateNaissanceMoment.format('DD/MM/YYYY') : dateNaissance}
                    </span>
                    {age && ` (${age} ans)`}
                </p>
            )}
            {permisActifs.map((p, i) => (
                <p key={i}>
                    Permis {p.TypePermis}
                    {p.DatePermis && ` : ${p.DatePermis._isAMomentObject ? p.DatePermis.format('L') : moment(p.DatePermis, 'DD/MM/YYYY').format('L')}`}
                </p>
            ))}
        </RecapGPTSection>
    );
};

export default RecapGPTConducteur;
